import { gql } from '@apollo/client';

export const GET_ALL_HOTEL_CHAT_USERS_QUERY = gql`
  query GetAllHotelChatUsers($hotelId: ID!) {
    guestChatAuthTokens(where: { hotel: $hotelId }, limit: -1) {
      id
      chatId
    }
  }
`;
